import { MULTIPLE_SPACES_REGEX } from 'constants/index';

export const stripMultipleSpaces = (value: string): string => {
  return value.replace(MULTIPLE_SPACES_REGEX, ' ');
};
